interface CyclesDisplayProps {
  /** Total successful inhale + exhale cycles */
  count: number;
  /** Session duration in seconds to display next to cycles */
  durationSeconds?: number;
}

function clampToNonNegative(value: number): number {
  if (Number.isNaN(value)) return 0;
  return Math.max(0, Math.floor(value));
}

function formatDuration(seconds?: number) {
  if (!seconds || Number.isNaN(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export default function CyclesDisplay({
  count,
  durationSeconds,
}: CyclesDisplayProps) {
  const safeCount = clampToNonNegative(count);

  return (
    <div className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-white/85 backdrop-blur-[4px] sm:px-3.5">
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60 sm:text-[10px]">
        Cycles
      </span>
      <span className="text-base font-semibold tabular-nums text-white/90 sm:text-sm">
        {safeCount}
      </span>
      {durationSeconds !== undefined && (
        <span className="ml-3 text-xs tabular-nums text-white/70">
          {formatDuration(durationSeconds)}
        </span>
      )}
    </div>
  );
}
